import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { NgxExtendedPdfViewerModule, pdfDefaultOptions } from 'ngx-extended-pdf-viewer';

import { SharedLanguageService } from '@language';
import { BaseViewerComponent } from '../base-viewer/base-viewer.component';

@Component({
    selector: 'sh-pdf-viewer',
    templateUrl: './pdf-viewer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgxExtendedPdfViewerModule]
})
export class PdfViewerComponent extends BaseViewerComponent {
    protected readonly translateService: SharedLanguageService = inject(SharedLanguageService);

    constructor(private readonly location: Location) {
        super();
        pdfDefaultOptions.assetsFolder = this.viewerFolder;
    }

    get language(): string {
        return this.translateService.getCurrentLanguage();
    }

    get viewerFolder(): string {
        const assetsPath: string = this.location.prepareExternalUrl('assets/pdfjs');
        return `${location.origin}${assetsPath}`;
    }
}
